var isUndefined = function isUndefined(value) {
  return value === undefined;
};

module.exports = isUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-undefined.js
// module id = 287
// module chunks = 0 1 2